module.exports = __webpack_public_path__ + "media/images/close-afc43a4374eb25754a2b71910f1959d9.svg";